<div style="padding: 0 5%">
  <div class="container" [ngSwitch]="mode">
    <div *ngSwitchCase="'form'">
      <app-template [title]="'Result Finalize'">
        <div class="search" style="padding-top: 30px">
          <div class="forms">
            <mat-form-field class="size">
              <mat-label>Start Date</mat-label>
              <input
                matInput
                [matDatepicker]="dob"
                (dateChange)="startDateChange($event)"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="dob"
              ></mat-datepicker-toggle>
              <mat-datepicker #dob></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="forms">
            <mat-form-field class="size">
              <mat-label>End Date</mat-label>
              <input
                matInput
                [matDatepicker]="end"
                (dateChange)="endDateChange($event)"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="end"
              ></mat-datepicker-toggle>
              <mat-datepicker #end></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="forms">
            <mat-form-field>
              <mat-label>Department</mat-label>
              <mat-select
                [(ngModel)]="dept_code"
                (selectionChange)="dept($event)"
                matNativeControl
              >
                <mat-option *ngFor="let dept of depts" [value]="dept.id">
                  {{ dept.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="forms">
            <mat-form-field>
              <mat-label>Sub Department</mat-label>
              <mat-select
                [(ngModel)]="sub_dept_code"
                (selectionChange)="sub($event)"
                matNativeControl
              >
                <mat-option *ngFor="let dept of subDepts" [value]="dept.id">
                  {{ dept.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="forms">
            <mat-form-field>
              <mat-label>Name</mat-label>
              <input [(ngModel)]="name" matInput placeholder="" />
            </mat-form-field>
          </div>
          <div class="forms">
            <mat-form-field>
              <mat-label>Mobile No.</mat-label>
              <input
                type="number"
                [(ngModel)]="phone"
                matInput
                placeholder=""
              />
            </mat-form-field>
          </div>
          <div class="forms" style="position: relative">
            <mat-form-field>
              <mat-label>Finalized</mat-label>
              <mat-select
                [(ngModel)]="is_finalized"
                (selectionChange)="finalized($event)"
                matNativeControl
              >
                <mat-option *ngFor="let ver of verif" [value]="ver.value">
                  {{ ver.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="forms" style="position: relative">
            <mat-form-field>
              <mat-label>Gender</mat-label>
              <mat-select [(ngModel)]="gender" matNativeControl>
                <mat-option value="Male">Male</mat-option>
                <mat-option value="Female">Female</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="forms">
            <mat-form-field>
              <mat-label>Investigation</mat-label>
              <input
                [(ngModel)]="investigation"
                (ngModelChange)="itemChange($event)"
                matInput
              />
              <div class="float" style="position: relative; width: 3px">
                <div class="ret" *ngIf="drVisible">
                  <div
                    class="list"
                    (click)="setitem(item)"
                    *ngFor="let item of filterddata"
                  >
                    {{ item.name }}
                  </div>
                </div>
              </div>
            </mat-form-field>
          </div>
          <div>
            <button
              (click)="getResult()"
              style="margin-left: 30px; margin-top: 20px"
              mat-raised-button
              color="primary"
            >
              Search
            </button>
          </div>
        </div>
        <div class="data">
          <div *ngIf="isLoading" style="margin-top: 50px" class="spinner">
            <mat-spinner></mat-spinner>
          </div>
          <table *ngIf="!isLoading" style="width: 100%">
            <tr class="back">
              <th>Patient Name</th>
              <th>Patient Age</th>
              <th>Patient Sex</th>
              <th>Date</th>
              <th>Service</th>
              <th>
                <!-- <button  mat-raised-button color="basic">
                            Clear All
                          </button> -->
              </th>
            </tr>
            <tr class="td" *ngFor="let item of data" style="cursor: pointer">
              <td>{{ item.PatientName }}</td>
              <td>{{ item.PatientAge }}</td>
              <td>{{ item.PatientGender }}</td>
              <td>
                <div>{{ item.StartDate | date }}</div>
                <div style="color: red">
                  {{ item.StartDate | date: "mediumTime" }}
                </div>
              </td>
              <td>{{ item.Title }}</td>
              <td>
                <button
                  (click)="addRecord(item)"
                  mat-raised-button
                  color="primary"
                >
                  View Result
                </button>
              </td>
            </tr>
          </table>
        </div>
      </app-template>
    </div>
    <div class="wizwig" *ngSwitchCase="'wiz'">
      <app-template [title]="'Format Result'">
        <button
          class="button"
          mat-raised-button
          color="primary"
          [matMenuTriggerFor]="menu"
          style="margin-left: 30px; width: 150px"
        >
          View Clinical History
        </button>
        <mat-menu #menu="matMenu" style="width: 400px">
          <div style="padding: 20px">
            {{ clinicalHistory }}
          </div>
        </mat-menu>
        <div class="form">
          <div class="space"></div>
          <form [formGroup]="stateForm" (ngSubmit)="Submit($event)">
            <mat-form-field>
              <mat-label>Comment</mat-label>
              <input
                formControlName="FinalizerComment"
                matInput
                placeholder="comment"
              />
            </mat-form-field>
            <div class="space"></div>
            <!-- <quill-editor formControlName="ResultBody" [styles]="{height: '300px'}"></quill-editor> -->
            <angular-editor
              [config]="editorConfig"
              [placeholder]="'Enter text here...'"
              formControlName="ResultBody"
            ></angular-editor>
          </form>
          <div class="errorMessage">
            <div *ngIf="Errors" class="error">
              <p>{{ Errors }}</p>
            </div>
          </div>
          <button
            (click)="back()"
            type="button"
            class="create"
            mat-raised-button
            color="primary"
          >
            Back
          </button>
          <button
            *ngIf="!isSaveLoading"
            (click)="done()"
            type="button"
            class="create"
            mat-raised-button
            color="primary"
          >
            Finalize
          </button>
          <button
            *ngIf="isSaveLoading"
            (click)="done()"
            type="button"
            class="create"
            mat-raised-button
            color="primary"
          >
            <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
          </button>
          <div class="space"></div>
        </div>
      </app-template>
    </div>
  </div>
</div>
